import type { PeriodCategory } from "../Calculator/types";

export const DEFAULT_PARAMS = {
	loanAmount: 20_000_000,
	maturity: 20,
	income: 400_000,
	realEstateValue: 40_000_000,
	numberOfChildrenCurrent: 0,
	numberOfChildrenCommitment: 0,
	eligibleForCsokPlus: true,
	qualifiesForHigherLtv: true,
	inKhr: undefined,
	qualifiesForVoluntaryInterestRateCap: false,
	eligibleForHomeStart: undefined,
};

export const INTEREST_PERIODS = [
	"FIVE_YEARS",
	"TEN_YEARS",
	"FIFTEEN_YEARS",
	"TWENTY_YEARS",
	"TWENTY_FIVE_YEARS",
	"THIRTY_YEARS",
	"FULL",
] as PeriodCategory[];
